<template>
  <div class="container">
    <router-view />
  </div>
</template>
<script>
import $utils from '../../utils/utils.js'
export default {
  mounted() {
    const isPhone = $utils.isMobile()
    if (isPhone) {
      document.body.className += ' phone-body'
    }
  }
}
</script>
<style scoped>
.container, .container>div {
  height: 100%;
}
</style>
